// @flow
import * as React from 'react';
import moment from 'moment';

import {
  Label, PrimaryText, HeaderText, Error,
} from '../../Typography.jsx';
import { Button } from '../../Buttons.jsx';

import styles from '../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  viewRow: ?Object,
  closeModal: Function,
}

class ViewVitalSigns extends React.Component<Props> {
  render() {
    const data = this.props.viewRow || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    let temperature;
    if (data.temperature === undefined || data.temperature === null) {
      temperature = '--';
    } else {
      const tempC = ((data.temperature - 32) * 5 / 9).toFixed(1);
      temperature = `${data.temperature} °F (${tempC} °C)`;
      if (data.temperature > data.tempMax) {
        temperature = <Error>{`${temperature} (H)`}</Error>;
      } else if (data.temperature < data.tempMin) {
        temperature = <Error>{`${temperature} (L)`}</Error>;
      }
    }

    let rr;
    if (data.rr === undefined || data.rr === null) {
      rr = '--';
    } else if (data.rr > data.rrMax) {
      rr = <span><Error>{`${data.rr} breaths per min (H)`}</Error></span>;
    } else if (data.rr < data.rrMin) {
      rr = <span><Error>{`${data.rr} breaths per min (L)`}</Error></span>;
    } else {
      rr = `${data.rr} breaths per min`;
    }

    let hr;
    if (data.hr === undefined || data.hr === null) {
      hr = '--';
    } else if (data.hr > data.hrMax) {
      hr = <span><Error>{`${data.hr} bpm (H)`}</Error></span>;
    } else if (data.hr < data.hrMin) {
      hr = <span><Error>{`${data.hr} bpm (L)`}</Error></span>;
    } else {
      hr = `${data.hr} bpm`;
    }

    let bp;
    if (data.bp === undefined || data.bp === null || data.bp === '') {
      bp = '--';
    } else {
      let [bpS, bpD] = data.bp.split('/');
      if (bpS > data.bpSMax) {
        bpS = <Error>{`${bpS} (H)`}</Error>;
      } else if (bpS < data.bpSMin) {
        bpS = <Error>{`${bpS} (L)`}</Error>;
      }
      if (bpD > data.bpDMax) {
        bpD = <Error>{`${bpD} (H)`}</Error>;
      } else if (bpD < data.bpDMin) {
        bpD = <Error>{`${bpD} (L)`}</Error>;
      }
      bp = <span>{bpS}/{bpD}</span>;
    }

    let spo2;
    const SPO2_MIN_THRESHOLD = 95;
    if (data.spo2 === undefined || data.spo2 === null) {
      spo2 = '--';
    } else if (data.spo2 < SPO2_MIN_THRESHOLD) {
      spo2 = <Error>{`${data.spo2}% (L)`}</Error>;
    } else {
      spo2 = `${data.spo2}%`;
    }

    return (
      <div>
        <HeaderText>Vital Signs</HeaderText>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Temperature </PrimaryText></td>
              <td>{temperature}</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>{data.temperatureSite || '--'}</td>
            </tr>
            <tr>
              <td><PrimaryText>Respiration Rate </PrimaryText></td>
              <td>{rr}</td>
            </tr>
            <tr>
              <td><PrimaryText>Heart Rate </PrimaryText></td>
              <td>{hr}</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>{data.hrSite || '--'}</td>
            </tr>
            <tr>
              <td><PrimaryText>Blood Pressure </PrimaryText></td>
              <td>{bp}</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>{data.bpSite || '--'}</td>
            </tr>
            <tr>
              <td><Label>Position</Label></td>
              <td>{data.bpPosition || '--'}</td>
            </tr>
            <tr>
              <td><PrimaryText>SpO2 </PrimaryText></td>
              <td>{spo2}</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>{data.spo2Site || '--'}</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.notes}>
          <PrimaryText>Notes</PrimaryText><br />
          {data.notes || '--'}
        </div>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Exam Date </PrimaryText></td>
              <td>{data.date ? moment(data.date).format('DD-MM-YYYY, HH:mm') : '--'}</td>
            </tr>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        <Button onClick={this.props.closeModal}>Close</Button>
      </div>
    );
  }
}

export default ViewVitalSigns;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/vitals/ViewVitalSigns.jsx